// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Enums
import { FundChartOptionValue } from 'ChartApp/ts/enums/fund-chart-common.enum';
// Action imports
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { setChartOption } from './chart-options.actions';
import { setFundChart } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart.actions';
// Constants
import { SCALE_TYPE_DEFAULT } from 'ChartApp/ts/features/fundamental-chart/constants';
export const scaleType = createReducer(SCALE_TYPE_DEFAULT, on(setChartData, (state, { chartData }) => chartData.params.scaleType), on(setChartOption, (state, action) => {
    if (action.chartOption.value === FundChartOptionValue.USE_LOG_SCALE) {
        return action.chartOption.selected
            ? action.chartOption.trueValue
            : action.chartOption.falseValue;
    }
    return state;
}), on(setFundChart, (state, action) => {
    return action.fundChart[FundChartOptionValue.USE_LOG_SCALE];
}));
